import React from "react";
import { FormInstance } from "antd/es/form";
import styles from "./ProductUpsellForm.module.scss";
import { SectionOneShotUpgradeInfo } from "./SectionOneShotUpgradeInfo";
import { SectionUpsellInfo } from "./SectionUpsellInfo";

function ProductUpsellForm({ form }: { form: FormInstance }) {
  return (
    <div className={styles.container}>
      <SectionUpsellInfo form={form} />

      <SectionOneShotUpgradeInfo form={form} />
    </div>
  );
}

export default ProductUpsellForm;
